import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Header from './components/Header';
import Footer from './components/Footer';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import ContactSection from './components/ContactSection';
// import TestimonialsSection from './components/TestimonialsSection';
import FAQSection from './components/FAQSection';
import AboutSection from './components/AboutSection';
import Pricing from './components/PricingSection';
import HowItWorksSection from './components/HowItWorks';

function App() {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);
  
  return (
    <div className="min-h-screen bg-gray-100">
      <Header />
      <main className="space-y-8">
        <HeroSection />
        <div className="p-4">
          <ServicesSection />
          <Pricing />
          <FAQSection />
          <AboutSection />
          <HowItWorksSection />
          <ContactSection />
          {/* <TestimonialsSection/> */}
        </div>
        <ToastContainer />
      </main>
      <Footer />
    </div>
  );
}

export default App;